import { ArgsType, Field, Float, Int } from '@nestjs/graphql'

@ArgsType()
export class CreateSubscriptionArgs {
  @Field()
  token!: string

  @Field()
  taxCode!: string

  @Field()
  cardId!: string

  @Field()
  cardLast4!: string

  @Field()
  cardBrand!: string

  @Field(t => Int)
  cardExpMonth!: number

  @Field(t => Int)
  cardExpYear!: number

  @Field()
  cardCountry!: string

  @Field(t => Float)
  total!: number

  @Field(t => Float)
  taxRate!: number

  @Field(t => Float, { nullable: true })
  extraTaxRate?: number

  @Field(t => Float)
  taxAmount!: number

  @Field(t => Float)
  subtotal!: number

  @Field()
  taxCountryCode!: string

  @Field()
  taxName!: string

  @Field({ nullable: true })
  extraTaxName?: string

  @Field()
  postalCode!: string

  @Field()
  plan!: string

  @Field()
  planCycle!: string

  @Field({ nullable: true })
  ipAddress?: string
}
